export const MoveableAssetsStyles = (theme) => ({
  mainDiv: {
    height: '100vh',
    overflow: 'auto',
  },
  tabsContainer: {
    margin: '10px',
  },
  table: {
    '& .ant-table-tbody > tr > td': {
      cursor: 'pointer',
    },
  },
  selectWithoutBorder: {
    '& .ant-select-selector': {
      border: 'none !important',
      boxShadow: 'none !important',
    },
  },
  refreshButton: {
    border: 'none',
    boxShadow: 'none',
  },
});
